/*
 * <hotspots-card-controller>
 * Two behaviours for the hotspot pin popovers in its section, independent of
 * the bundle's trigger path (so they also work for the mobile popover):
 *   1. Single-open — opening one float card closes any other open one.
 *   2. Click/tap outside an open card closes it.
 * Hooks the bundle's own <hotspots-float-element> event bus (.on('show'))
 * and API (.hide() / .isOpen) — no MutationObserver.
 */
class HotspotsCardController extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.hotspots');
    if (!this.section) return;

    this.floats = [];
    this.handlers = new Map();
    this.onDocPointer = this.onDocPointer.bind(this);

    customElements.whenDefined('hotspots-float-element').then(() => {
      if (!this.isConnected) return;
      this.floats = Array.from(this.section.querySelectorAll('hotspots-float-element'));
      this.floats.forEach((floatEl) => {
        if (typeof floatEl.on !== 'function') return;
        const handler = () => this.closeOthers(floatEl);
        this.handlers.set(floatEl, handler);
        floatEl.on('show', handler);
      });
    });

    document.addEventListener('click', this.onDocPointer, true);
  }

  // Single-open: hide every open float except the one that just opened.
  closeOthers(except) {
    this.floats.forEach((floatEl) => {
      if (floatEl !== except && floatEl.isOpen && typeof floatEl.hide === 'function') {
        floatEl.hide();
      }
    });
  }

  // Outside click/tap closes any open card. Taps on a pin trigger are left to
  // the bundle (the single-open handler then closes the previous one).
  onDocPointer(event) {
    if (event.target.closest('.hotspots__pin-wrapper')) return;
    this.floats.forEach((floatEl) => {
      if (floatEl.isOpen && !floatEl.contains(event.target) && typeof floatEl.hide === 'function') {
        floatEl.hide();
      }
    });
  }

  disconnectedCallback() {
    this.handlers.forEach((handler, floatEl) => {
      if (typeof floatEl.off === 'function') floatEl.off('show', handler);
    });
    this.handlers.clear();
    document.removeEventListener('click', this.onDocPointer, true);
  }
}

if (!customElements.get('hotspots-card-controller')) {
  customElements.define('hotspots-card-controller', HotspotsCardController);
}
